import { Injectable } from '@angular/core';
import { ServerService } from '../../services/ServerService';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WhatsappTrialService extends ServerService {
    constructor(protected http: HttpClient) {
        super(http);
    }

  ativarTrial() {
    return super.facaPost('configuracoesMia/ativarTrial', {});
  }

  obterStatusTrial() {
    return super.obtenha('configuracoesMia/statusTrial', {});
  }
}
